// extracted by mini-css-extract-plugin
export default {"cardList":"CardList_cardList__zGLXH","isMedium":"CardList_isMedium__pzSEJ","fullWidth":"CardList_fullWidth__9BLHw","isInsideTabs":"CardList_isInsideTabs__-epva"};